import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import TrackerEditMeal from '../components/TrackerEditMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeTrackerMeal } from '../helpers/normalizers';
import { TrackerMealProps } from '../types';

const TrackerMealContainer: React.FC<TrackerMealProps> = (props) => {
  const normalizedProps = normalizeTrackerMeal(props);

  return (
    <TrackerEditMeal
      key={normalizedProps.mealData.id}
      {...normalizedProps}
      mode="backward-navigation"
    />
  );
};

export default withLoading(TrackerMealContainer, UniversalPlaceholder);
